export class DefaultSet {
  public _set = (object: any) => {
    Object.assign(this, object);
    return this;
  };
}
